export default __webpack_public_path__ + "static/media/bg-buildings.8979d395.png";